import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Helmet from 'react-helmet';
import Authorization from '../authorization/authorization';
import DashboardBuilderPage from '../pages/dashboards/dashboardBuilder';
import NotFound from '../pages/notFound/notFound';
import LoginPage from '../pages/login/login';
import ResetPasswordPage from '../pages/reset_password/reset_password';
import ResetPasswordRequestPage from '../pages/reset_password_request/reset_password_request';
import PrivacyPolicyPage from '../pages/privacyPolicy/privacyPolicy';
import { ROLE_SETS } from '../authorization/roles';
import './app.css';

import 'url-search-params-polyfill';

const HomePage = () => <Redirect to="/auth/login" />;
const DashboardBuilder = Authorization(ROLE_SETS.all)(DashboardBuilderPage);

class App extends Component {
  render() {
    return (
      <div className="app">
        <Helmet>
          <title>SOW Evangelism</title>
          <link href="https://fonts.googleapis.com/css?family=Open+Sans" rel="stylesheet" />
        </Helmet>

        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route path="/dashboard/:churchId?" component={DashboardBuilder} />

          <Route path="/privacyPolicy" component={PrivacyPolicyPage} />
          <Route path="/auth/login" component={LoginPage} />
          <Route path="/auth/reset_password_request" component={ResetPasswordRequestPage} />
          <Route path="/auth/reset_password/:token" component={ResetPasswordPage} />
          <Route path="/404" component={NotFound} />
          <Redirect to="/404" />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/app/app.js